import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue";
import "./utils/router"; // 1. 先导入我们重写后的 router 工具文件
import router from "./router";
import store from "./store";
import download from "@/utils/request";
import "@/assets/styles/common.less"; // global css
import "@/assets/styles/rich-text.css"; // rich-text css
import {
  parseTime,
  resetForm,
  addDateRange,
  selectDictLabel,
  selectDictLabels,
  handleTree,
} from "@/utils/ruoyi";
//轮播图组件
import VueAwesomeSwiper from "vue-awesome-swiper";
Vue.use(VueAwesomeSwiper);
import "swiper/dist/css/swiper.css";
// 引入字体样式
import "@/assets/font/font.css";

Vue.prototype.download = download;
Vue.use(VueAwesomeSwiper);
import VueAnimateNumber from "vue-animate-number";
Vue.use(VueAnimateNumber);
// 自定义轮播图工具组件
import swipertemp from "./components/swipertemp/index.vue";
// 自定义图片组件
import Imgtemp from "./components/Imgtemp/index.vue";
// 自定义产品推荐组件
import ProductRecommendation from "./components/productRecommendation/index.vue";
// 自定义产品详情组件
// 拼接的展示图片或者是视频地址
// Vue.prototype.PinjieImgUrl = "http://192.168.0.122:8081";
Vue.prototype.PinjieImgUrl = "http://120.27.122.161:8081";
// 全局组件挂载
Vue.component("swipertemp", swipertemp);
Vue.component("Imgtemp", Imgtemp);
Vue.component("ProductRecommendation", ProductRecommendation);
Vue.prototype.handleTree = handleTree;
Vue.prototype.parseTime = parseTime;
// 大屏自适应
import VScaleScreen from "v-scale-screen";
Vue.use(VScaleScreen);
// 大屏自适应2
import ScaleBox from "vue2-scale-box";
Vue.use(ScaleBox);
import "animate.css";

// 在 main.js 或组件中引入
import _ from "lodash";
// 关键：引入 amfe-flexible（动态设置 html 根字体大小，实现 rem 基准值自适应）
import 'amfe-flexible'
// 1. 引入 vue2-animate
// import Vue2Animate from "vue2-animate";
// 2. 引入 vue2-animate 的 CSS 文件
// import "vue2-animate/dist/vue2-animate.css";
// 3. 注册 vue2-animate
// Vue.use(Vue2Animate);
Vue.config.productionTip = false;
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
